import React from 'react'
import { Link } from 'react-router-dom'
import buildQuery from '../../helpers/buildQuery'

function Sections({sections, suggested, student, customer, probeClick, url, suggestedStory})
{
    return (<div class = "row">
                <div class = "col-sm-10 offset-sm-1">
                    <div class = "panel-group" id = "accordion">
                    {
                        sections.map((section) =>
                        {
                            return <React.Fragment>
                                    <div class = {`card mb-1 ${section.number === suggested.section ? "active" : ""}`}>
                                        <a data-toggle = "collapse" data-parent = "#accordion" href = {`#section-${section.number}`}>
                                            <div class = "card-header">
                                                <h6 class = "card-title mb-0">Section - {section.number} {section.title}</h6>
                                            </div>
                                        </a>
                                        <div id = {`section-${section.number}`} class = {`${section.number === suggested.section ? "" : "collapse"} `}>
                                            <div class = "card-body list-group pb-0">
                                            {
                                                section.probes.map((probe) =>
                                                {
                                                    const standardVariables = buildQuery({ student: student, customer: customer })
                                                    return  <Link
                                                                to = {`${url}/${probe.number}?${standardVariables}${suggestedStory ? `&suggestedStory=${suggestedStory}` : ""}`}
                                                                class = {`list-group-item list-group-item-action ${probe.number === suggested.number ? "active" : ""}`}
                                                                onClick={(event) => { probeClick(event, probe.number) }}>
                                                                    <h5 class = "list-group-item-heading m-0" style = {{ pointerEvents: "none" }}><strong>Exercise {probe.number}</strong></h5>
        
                                                                    <p class = "list-group-item-text m-0" style = {{ pointerEvents: "none" }}>{probe.title}</p>
                                                                </Link>
                                                })
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                        })
                    }
                    </div>
                </div>
            </div>)
}

export default Sections
